<template>
  <div class="c-app flex-row align-items-center">
    <CContainer>
      <CRow class="justify-content-center">
        <CCol md="8">
          <CCardGroup>
            <CCard class="p-4">
              <CCardBody>
                <CForm @submit.prevent="Authentication">
                  <h1>МС-Ресурс</h1>
                  <p class="text-muted">Вход в личный кабинет</p>
                  <CRow>
                    <CCol class="text-center text-danger">
                      {{ store.getters.error }}
                    </CCol>
                  </CRow>
                  <CInput
                    placeholder="Email"
                    required="required"
                    autocomplete="Email пользователя"
                    id="email" v-model="email"
                  >
                    <template #prepend-content><CIcon name="cil-user"/></template>
                  </CInput>
                  <CInput
                    placeholder="Пароль"
                    type="password"
                    required="required"
                    autocomplete="curent-password"
                    id="password" v-model="password"
                  >
                    <template #prepend-content><CIcon name="cil-lock-locked"/></template>
                  </CInput>

                  <CRow>
                    <CCol col="6" class="text-left">
                      <CButton color="primary" type="submit" class="px-4">Вход</CButton>
                    </CCol>
                    <CCol col="6" class="text-right">
                      <router-link :to="{name: 'ForgotPassword'}">Забыли пароль?</router-link>
                      <CButton color="link" class="d-lg-none">Регистрация</CButton>
                    </CCol>
                  </CRow>
                </CForm>
              </CCardBody>
            </CCard>
            <CCard
              color="primary"
              class="text-center py-5 "
              body-wrapper
            >
              <CCardBody>
                <CForm @submit.prevent="checkAct">
                <h2 class="text-white">База поверок</h2>
                <CRow>
                  <CCol sm="12">
                    <CCard>

                      <CCardBody>
                        <CRow>
                          <CCol sm="4">
                            <CInput
                              v-model="id1"
                              required="required"
                                placeholder="***"
                            />
                          </CCol>
                          <CCol sm="4">
                            <CInput
                              v-model="id2"
                              required="required"
                                placeholder="**"
                            />
                          </CCol>
                          <CCol sm="4">
                            <CInput
                              v-model="id3"
                              required="required"
                                placeholder="*****"
                            />
                          </CCol>
                        </CRow>
                        <CRow>
                          <CCol sm="12">
                            <CInput
                              v-model="pin"
                              required="required"
                                label="Пин-код"
                                placeholder="Введите пин-код поверки"
                            />
                          </CCol>
                        </CRow>
                      </CCardBody>
                    </CCard>
                  </CCol>
                </CRow>
                <CButton
                  color="light"
                  variant="outline"
                  type="submit"
                  size="lg"
                >
                  Найти поверку!
                </CButton>
                </CForm>
              </CCardBody>
            </CCard>
          </CCardGroup>
        </CCol>
      </CRow>
    </CContainer>
  </div>
</template>

<script lang="ts">
import { computed, defineComponent, ref } from '@vue/composition-api'
import { AUTH_REQUEST, AUTH_CONFIRM } from '@/api/auth'

const required = val => !!val
const minLength = num => val => val.length >= num

export default defineComponent ({
  created () {
    if (this.isAuth) {
      this.$router.push('Home')
    }
  },
  setup (props, ctx) {
    const email = ref('')
    const password = ref('')
    const code = ref(null)
    const store = ctx.root.$store
    const passwordType = ref('password')

    const id1 = ref(null);
    const id2 = ref(null);
    const id3 = ref(null);
    const pin = ref(null);

    const id = computed( () => {
      return `${id1.value}-${id2.value}-${id3.value}`;
    })

    const Authentication = () => {
      AUTH_REQUEST({ email: email.value, password: password.value })
    }

    const clear = () => {
      store.dispatch('AUTH_CANCEL')
    }

    const isAuth = computed(() => {
      return store.getters.isAuthenticated
    })

    const errors = computed(() => {
      return store.getters.error
    })

    const checkAct = () => {
      document.location = `/up?id=${id.value}&pin=${pin.value}`;
    }

    return {
      Authentication,
      email,
      password,
      store,
      code,
      isAuth,
      passwordType,
      clear,
      checkAct,
      id1, id2, id3, pin
    }
  },
})


</script>
